// extracted by mini-css-extract-plugin
export default {"uploadBtn":"w2GgGLZqtBKc3HJqUPWq"};